import { createStyles } from '@material-ui/core';

export const containerStyles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
});
